import { useMutation } from '@tanstack/react-query'
import { postContactCase } from 'services/ContactService'

export const usePostContactCaseMutation = () => {
  return useMutation({ mutationFn: postContactCase })
}
